// extracted by mini-css-extract-plugin
export default {"phone":"Form_phone__016SI","text":"Form_text__wokG+","button":"Form_button__6HESe","test":"Form_test__PW-Cx"};